export class ExpenseDealership {
    expense: string = "";
    actual: string = "";
    expenseNum: number = 0;
    actualNum: number = 0;
    id: number = 0;
    exist: boolean = true;
    hasInvoices:boolean = false;
    constructor(category, product, subproduct, rooftopId) {
        if (category) {
            this.setId(category.id);
        }
        if (product) {
            if (product.dealerShips) {
                this.setId((product.dealerShips[rooftopId].expenseId === undefined) ? 0 : product.dealerShips[rooftopId].expenseId);
            } else {
                this.setId(0);
            }
        }
        if (subproduct) {
            this.setId((subproduct.dealerShips[rooftopId].expenseId === undefined) ? 0 : subproduct.dealerShips[rooftopId].expenseId);
        }
    }
    public setPlaned(val:number) {
        this.expenseNum = val;
        this.expense = this.checkDecimal(this.expenseNum);
    }
    public setExist(value: boolean) {
        this.exist = value;
    }
    public convertTextExpense() {
        if (!this.exist) {
            this.expense = "-";
        } else {
            this.expense = this.checkDecimal(this.expenseNum);
        }

    }
    public setActual(val:number) {
        this.actualNum = val;
        this.actual = this.checkDecimal(this.actualNum);
    }
    public convertTextActual() {
        if (!this.exist) {
            this.expense = "-";
        } else {
        this.actual = this.checkDecimal(this.actualNum);
        }
    }
    public setId(id) {
        this.id = id;
    }
    checkDecimal(n) {
        if (n % 1 === 0) {
            return `${n.toLocaleString('en')}`
        }
        var c = 2,
            d = ".",
            t = ",",
            s = n < 0 ? "-" : "",
            i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))),
            j = (j = i.length) > 3 ? j % 3 : 0;
        return `${s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - parseFloat(i)).toFixed(c).slice(2) : "")}`;
    }

}


// WEBPACK FOOTER //
// ./src/app/components/budget/right-panel/class/expense-dealership.ts